/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import DashboardMyFrac from '@/components/dashboards/dashboard'
import Events from '@/components/events/Events'
import MassiveEvents from '@/components/events/MassiveEvents'
import GuestList from '@/components/events/GuestList2'
import ContractorsTable from '@/components/contractors/contractorsTable'
import CreateContractor from '@/components/contractors/createContractor'
import ConstructionTable from '@/components/constructions/constructionsTable'
import ConstructionTable2 from '@/components/constructions/constructionsTable2'
import CreateConstruction from '@/components/constructions/createConstruction'
import WorkersTable from '@/components/workers/workersTable'
import Workers from '@/components/workers/workers'
import WorkersRequest from '@/components/workers/workersRequest'
import configuration from '@/components/configuration/configuration'
import resetPassword from '@/components/resetPassword'
import NotFound404 from '@/components/NotFound404'

//ADMINISTRACION
import users from '@/components/administracion/users'
import qrcodes from '@/components/administracion/qrcodes'
import residents from '@/components/administracion/residents'
import residentsFaces from '@/components/administracion/residentsAdministration/massiveFacialLoad'
import FacialIngest from '../components/administracion/residentsAdministration/facial-ingest/FacialIngest.vue'
import createResidents from '@/components/administracion/createResident'
import visitants from '@/components/administracion/reports'
import commonAreaVisitants from '@/components/administracion/reportsCA'
import facialVisitsReport from '@/components/administracion/facialVisitsReport'
import usersTypes from '@/components/administracion/usersTypes'
import carbrands from '@/components/administracion/carbrands'
import colors from '@/components/administracion/colors'
import providers from '@/components/administracion/providers'
//CATALOGOS
import gates from '@/components/catalogos/gates'
import zones from '@/components/catalogos/zones'
import streets from '@/components/catalogos/streets'
import commonareas from '@/components/catalogos/commonareas'
//COMUNIDAD
import notices from '@/components/comunidad/notices'
import createNotices from '@/components/comunidad/createNotice'
import newsletters from '@/components/comunidad/newsletters'
import createNew from '@/components/comunidad/createNew'
import promotions from '@/components/comunidad/promotions'
import createPromotion from '@/components/comunidad/createPromotion'

import fracs from '@/components/administracion/fracs'
import createFrac from '@/components/administracion/createFrac'
import integrators from '@/components/administracion/integrators'
import createIntegrator from '@/components/administracion/createIntegrator'

const ResidentsBase = { render: h => h('router-view') }

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/home",
      name: "Dashboard My Frac",
      component: DashboardMyFrac,
      beforeEnter(to, from, next) {
        if (localStorage.getItem("access_token")) {
          next();
        } else {
          next("/");
        }
      },
    },
    {
      path: "/create",
      name: "Create event",
      component: Events,
    },
    {
      path: "/massiveEvents",
      name: "List of Events",
      component: MassiveEvents,
    },
    {
      path: "/guests",
      name: "List of Guests",
      component: GuestList,
    },
    // MODULO CONTRATISTAS
    {
      path: "/contractors",
      name: "List of Contractors",
      component: NotFound404,
      // component: ContractorsTable,
    },
    {
      path: "/createContractor",
      name: "Create contractor",
      component: NotFound404,
      // component: CreateContractor,
    },
    {
      path: "/constructions",
      name: "List of Constructions",
      component: NotFound404,
      // component: ConstructionTable,
    },
    {
      path: "/constructions_contractor",
      name: "List of Constructions by contractor",
      component: NotFound404,
      // component: ConstructionTable2,
    },
    {
      path: "/createConstruction",
      name: "Create construction",
      component: NotFound404,
      // component: CreateConstruction,
    },
    {
      path: "/workers",
      name: "List of Workers",
      component: NotFound404,
      // component: WorkersTable,
    },
    {
      path: "/createWorker",
      name: "Create worker",
      component: NotFound404,
      // component: Workers
    },
    {
      path: "/workersRequest",
      name: "workers request",
      component: NotFound404,
      // component: WorkersRequest
    },

    {
      path: "/configuration",
      name: "Ajustes",
      component: configuration,
    },
    {
      path: "/gates",
      name: "Puertas de acceso",
      component: gates,
    },
    {
      path: "/zones",
      name: "Zonas",
      component: zones,
    },
    {
      path: "/streets",
      name: "Calles",
      component: streets,
    },
    {
      path: "/commonareas",
      name: "áreas comunes",
      component: commonareas,
    },
    {
      path: "/users",
      name: "Usuarios",
      component: users,
    },
    {
      path: "/providers",
      name: "Provedores",
      component: providers,
    },
    {
      path: "/qrcodes",
      name: "Dispositivos",
      component: qrcodes,
    },
    {
      path: '/residents',
      component: ResidentsBase,
      redirect: '/residents/admin',
      children: [
        {
          path: 'admin',
          name: 'ResidentsAdmin',
          component: residents,
          meta: { roles: ['Administrador de fraccionamiento', 'Capturista'] }
        },
        // {
        //   path: 'faces',
        //   name: 'ResidentsFaces',
        //   component: residentsFaces,
        //   meta: { roles: ['Administrador de fraccionamiento', 'Capturista'] }
        // }
        {
          path: 'faces',
          name: 'ResidentsFaces',
          component: FacialIngest,
          meta: { roles: ['Administrador de fraccionamiento', 'Capturista'] }
        }
      ]
    },
    {
      path: "/newResidents",
      name: "Crear Residentes",
      component: createResidents,
    },
    {
      path: "/visitants",
      name: "Visitantes",
      component: visitants,
    },
    {
      path: "/commonAreaVisitants",
      name: "reporte areas comunes",
      component: commonAreaVisitants,
    },
    {
      path: "/facialVisits",
      name: "Reporte accesos faciales",
      component: facialVisitsReport,
    },
    {
      path: "/notices",
      name: "Noticias",
      component: notices,
    },
    {
      path: "/newNotice",
      name: "Nuevo aviso",
      component: createNotices,
    },
    {
      path: "/newsletters",
      name: "Boletines",
      component: newsletters,
    },
    {
      path: "/newNews",
      name: "Nuevo boletin",
      component: createNew,
    },
    {
      path: "/promotions",
      name: "Promociones",
      component: promotions,
    },
    {
      path: "/newPromotion",
      name: "Nueva promoción",
      component: createPromotion,
    },
    {
      path: "/resetPassword",
      name: "restablecer contraseña",
      component: resetPassword,
    },
    {
      path: "/fracs",
      name: "Fraccionamientos",
      component: fracs,
      beforeEnter: (to, from, next) => {
        var role = localStorage.getItem("role");
        if (role === "Integrador") {
          next();
        } else {
          next("/home");
        }
      },
    },
    {
      path: "/newFrac",
      name: "Nuevo Fraccionamiento",
      component: createFrac,
    },
    {
      path: "/integrators",
      name: "Integradores",
      component: integrators,
      beforeEnter: (to, from, next) => {
        var role = localStorage.getItem("role");
        if (role === "Administrador general") {
          next();
        } else {
          next("/home");
        }
      },
    },
    {
      path: "/newIntegrator",
      name: "Crear integrador",
      component: createIntegrator,
    },
    {
      path: "/users-types",
      name: "Tipos de usuario",
      component: usersTypes,
      beforeEnter: (to, from, next) => {
        var role = localStorage.getItem("role");
        if (role === "Administrador general") {
          next();
        } else {
          next("/home");
        }
      },
    },
    {
      path: "/carbrands",
      name: "Marcas de automovil",
      component: carbrands,
      beforeEnter: (to, from, next) => {
        var role = localStorage.getItem("role");
        if (role === "Administrador general") {
          next();
        } else {
          next("/home");
        }
      },
    },
    {
      path: "/colors",
      name: "Colores",
      component: colors,
      beforeEnter: (to, from, next) => {
        var role = localStorage.getItem("role");
        if (role === "Administrador general") {
          next();
        } else {
          next("/home");
        }
      },
    },
    {
      path: "/",
      name: "login",
      beforeEnter: (to, from, next) => {
        var token = localStorage.getItem("access_token");
        if (token == null) {
          next();
        } else {
          next("/home");
        }
      },
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});
